import type * as React from 'react';

import { useTranslation } from '@crehana/i18n';

import { SocialButtonsV2, Title } from '../components';
import type { AuthInnerFormProps, OnChangeForm } from '../types';
import { getNextUrl, redirectWithQueryParams } from '../utils';
import SigninForm from './SigninForm';

type SignInProps = {
  onCustomSuccess: AuthInnerFormProps['onCustomSuccess'];
  emailDefault?: string;
  organization?: {
    slug: string;
  };
  nextUrl?: string;
  isOrganization?: boolean;
  isDark?: boolean;
  onChangeForm?: OnChangeForm;
};

const SignIn: React.FC<React.PropsWithChildren<SignInProps>> = ({
  nextUrl: _nextUrl,
  onCustomSuccess,
  emailDefault,
  organization,
  isDark,
  onChangeForm,
}) => {
  const { t } = useTranslation();
  const nextUrl = _nextUrl || getNextUrl();

  const toggleView = () => {
    if (onChangeForm) {
      // the arg that onChangeForm recevies is the current view
      onChangeForm('register');
    } else {
      redirectWithQueryParams('/registro/');
    }
  };

  const recoverPasswordLink = organization
    ? `/org/${organization.slug}/olvidaste-contrasena/`
    : '/entrar/olvidaste-contrasena/';

  return (
    <div>
      <Title formView="login" isDark={isDark} />
      <div
        style={{
          maxWidth: 320,
          margin: 'auto',
        }}
      >
        <div className="mb-32">
          <SocialButtonsV2
            nextUrl={nextUrl}
            getNextUrl={getNextUrl}
            isDark={isDark}
            formView="login"
          />
        </div>
        <SigninForm
          onCustomSuccess={onCustomSuccess}
          emailDefault={emailDefault}
          organization={organization}
          nextUrl={nextUrl}
          isDark={isDark}
        />
      </div>
      <div className="flex justify-center items-center mt-32">
        <span
          className={`${isDark ? 'text-white' : ''} font-body4 block mr-12`}
        >
          {t('YOU_HAVE_NOT_ACCOUNT', {
            defaultValue: '¿Aún no tienes una cuenta?',
          })}
        </span>{' '}
        <button type="button" onClick={toggleView}>
          <span className="text-green-main font-body4 tw-font-semibold">
            {t('SIGN_UP', {
              defaultValue: 'Regístrate',
            })}
          </span>
        </button>
      </div>
      <div className="text-center">
        <a
          href={recoverPasswordLink}
          className="mt-16 block text-center w-full"
        >
          <span className="font-link text-green-main">
            {t('FORGOT_PASSWORD', {
              defaultValue: 'Olvidé mi contraseña',
            })}
          </span>
        </a>
      </div>
    </div>
  );
};

export default SignIn;
